import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-upload-transfer-list",
  templateUrl: "./upload-transfer-list.component.html",
  styleUrls: ["./upload-transfer-list.component.css"],
})
export class UploadTransferListComponent implements OnInit {
  JSONData: any;
  constructor(
    public dialogRef: MatDialogRef<UploadTransferListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  closeDialog() {}

  csvJSON(csvText) {
    let lines = csvText.split("\n");
    let result = [];
    let headers = lines[0].split(",");
    //  console.log(headers);
    for (var i = 1; i < lines.length - 1; i++) {
      let obj = {};
      let currentline = lines[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }
    this.JSONData = JSON.stringify(result);
    //  this.autoCompleteForm(result);

    this.dialogRef.close(result);
  }

  convertFile(input) {
    const reader = new FileReader();
    reader.readAsText(input.files[0]);
    reader.onload = () => {
      let text = reader.result;
      //  console.log(text);
      this.csvJSON(text);
    };
  }
}
